import { render, staticRenderFns } from "./DraggableImage.vue?vue&type=template&id=0284984e&scoped=true&lang=pug&"
import script from "./DraggableImage.vue?vue&type=script&lang=js&"
export * from "./DraggableImage.vue?vue&type=script&lang=js&"
import style0 from "./DraggableImage.vue?vue&type=style&index=0&id=0284984e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0284984e",
  null
  
)

export default component.exports